<div class="bz-form-item--required bz-form-item bz-space--stack-m"
    [ngClass]="{'bz-form-item--error' : (dpDateControl.invalid) && (dpDateControl.dirty || dpDateControl.touched)}">
    <label class="bz-form-label" for="{{id}}" *ngIf="hasLabel">
        <span #inputLabel>
            <ng-content></ng-content>
        </span>
        <span class="bz-required__icon" *ngIf="required">*</span>
    </label>
    <div class="bz-input-icon">
        <input class="bz-input bz-input-icon__input bz-space--inline-s" 
                autocomplete="off" 
                placeholder="{{'GLOBAL.SELECT_A_DATE' | translate}}"
                mask="00/00/0000" 
                id="{{id}}" 
                #dpDate="bsDatepicker" 
                #dpDateControl="ngModel" 
                [(ngModel)]="value" 
                name="dpDateControl"
                [bsConfig]="getConfiguration()" 
                [required]="required" 
                bsDatepicker>
        <svg class="bz-icn bz-space--inline-s" height="32px" width="32px" (click)="dpDate.show()">
            <use xlink:href="#icon-calendar"></use>
        </svg>
    </div>
    <div class="bz-form-message">
        <span class="bz-form-message__error">
            <svg class="bz-icn bz-space--inline-s" width="16px" height="16px">
                <use xlink:href="#icn-input-error" />
            </svg>
            <label class="bz-form-message__text">
                {{'GLOBAL.REQUIRED_FIELD' | translate}}
            </label>
        </span>
    </div>
</div>
